module.exports = {
      id: "lulu-money-usage",
      viewBox: "0 0 398 134",
      url: __webpack_public_path__ + "svg-sprite-0ef3134280a050ca46b4726dfe0fed42.svg#lulu-money",
      toString: function () {
        return this.url;
      }
    }